import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { baseUrl } from "../shared/baseUrl";

function Tafsir({ queue, setQueue, setCurrent, setPlaying, liked, setLiked }) {
  const [tafsirData, settafsirData] = useState(null);
  const [tafsirAudioList, setTafsirAudioList] = useState([]);
  const { tafsirSlug } = useParams();

  useEffect(() => {
    fetch(baseUrl + `api/v1/tafsir/${tafsirSlug}`)
      .then((res) => res.json())
      .then((data) => {
        settafsirData(data);
        setTafsirAudioList(Array.isArray(data.audio) ? data.audio : []);
      })
      .catch(() => {
        settafsirData(null);
        setTafsirAudioList([]);
      });
  }, [tafsirSlug]);

  const normalizeAudio = (tafsir, tafsirData) => ({
    id: tafsir.id,
    title: tafsirData.title,
    reciter: tafsirData.reciter,
    riwaya: "Tafsir",
    cover: `${tafsirData.image}`,
    src: `${tafsir.path}`,
  });

  const playAudio = (tafsir) => {
    const normalized = normalizeAudio(tafsir, tafsirData);

    // Copy queue and find index
    let newQueue = [...queue];
    let index = newQueue.findIndex((s) => s.id === normalized.id);

    if (index === -1) {
      newQueue.push(normalized);
      index = newQueue.length - 1;
    }

    setQueue(newQueue);
    setCurrent(index);
    setPlaying(true);
  };

  const toggleLike = (tafsir) => {
    const normalized = normalizeAudio(tafsir, tafsirData);

    let newLiked;
    if (liked.includes(normalized.id)) {
      newLiked = liked.filter((id) => id !== normalized.id);
    } else {
      newLiked = [...liked, normalized.id];

      // Add to queue if not present
      if (!queue.find((q) => q.id === normalized.id)) {
        setQueue([...queue, normalized]);
      }
    }

    setLiked(newLiked);
    localStorage.setItem("likedAudioList", JSON.stringify(newLiked));
  };

  const playTafsir = () => {
    const normalizedAudioList = tafsirAudioList.map((s) =>
      normalizeAudio(s, tafsirData),
    );

    // Merge new audio list into queue without duplicates
    const newQueue = [...queue];
    normalizedAudioList.forEach((s) => {
      if (!newQueue.find((q) => q.id === s.id)) newQueue.push(s);
    });

    setQueue(newQueue);

    // Start with first narration audio index in the updated queue
    const firstIndex = newQueue.findIndex(
      (q) => q.id === normalizedAudioList[0].id,
    );
    setCurrent(firstIndex);
    setPlaying(true);
  };

  if (!tafsirData) {
    return (
      <div className="narration-audio-list">
        <p>Loading Tafsir...</p>
      </div>
    );
  }

  return (
    <div className="narration-audio-list">
      <div className="narration-hero">
        <img
          className="narration-hero-image"
          src={`${baseUrl}storage/${tafsirData.image}`}
          alt={tafsirData.author}
        />

        <div className="narration-hero-info">
          <h1 className="narration-title">{tafsirData.title}</h1>
          <div className="narration-meta">
            <span className="reciter-name">{tafsirData.author}</span>
            <span className="reciter-name">
              <br />
              Lang: {tafsirData.language}
            </span>
          </div>

          <button className="play-all-btn" onClick={playTafsir}>
            ▶ Play All
          </button>
        </div>
      </div>

      <table className="list-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Play / ❤️</th>
          </tr>
        </thead>
        <tbody>
          {tafsirAudioList.map((tafsir, index) => (
            <tr key={tafsir.id}>
              <td>{index + 1}</td>
              <td>{tafsirData.title}</td>
              <td>
                <button onClick={() => playAudio(tafsir)}>▶</button>

                <span className="liked">
                  <button onClick={() => toggleLike(tafsir)}>
                    {liked.includes(tafsir.id) ? "❤️" : "🤍"}
                  </button>
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Tafsir;
